const typeMap = new Map();

typeMap.set('d1', 1191);
typeMap.set('d2', 1201);
typeMap.set('d3', 1211);
typeMap.set('aoy', 91);
typeMap.set('roy', 90);
typeMap.set('eqs', 99);
typeMap.set('opens', 501);
typeMap.set('eastern', 531);
typeMap.set('eastern', 530);
typeMap.set('central', 551);
typeMap.set('central', 550);
typeMap.set('northern', 511);
typeMap.set('northern', 510);
typeMap.set('southern', 520);
typeMap.set('southern', 520);
typeMap.set('western', 541);
typeMap.set('western', 540);
typeMap.set('kayak', 1);
typeMap.set('eqs', 99);
typeMap.set('basstrakk', 'basstrakk');
typeMap.set('coanglers', 'coanglers');
typeMap.set('bigbass', 'bigbass');
typeMap.set('catches', 'catches');

export default typeMap;
